import React, { useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Dispatch } from 'redux'
import { logout } from '../../actions/auth'
import { HeaderTemplate } from '../../layouts'
import SearchPanel from '../SearchPanel'
import { HeaderLogo } from './HeaderLogo'
import { HeaderActions } from './HeaderActions'
import { LogOutModal } from './LogOutModal'

export interface IHeader {
  displaySettingsIcon: boolean
  overlayIsShown: boolean
  dispatch: Dispatch
}

export const Header = ({
  displaySettingsIcon,
  overlayIsShown,
  dispatch,
}: IHeader) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <HeaderTemplate
        logo={<HeaderLogo overlayIsShown={overlayIsShown} />}
        search={
          <Switch>
            <Route path="/group/:groupId/" component={SearchPanel} />
            <Route path="/consumersearch" component={SearchPanel} />
          </Switch>
        }
        actionPrimary={
          <HeaderActions
            displaySettingsIcon={displaySettingsIcon}
            overlayIsShown={overlayIsShown}
            handleLogout={() => setOpen(true)}
          />
        }
      />
      <LogOutModal
        open={open}
        closeAction={() => setOpen(false)}
        submitAction={() => dispatch(logout())}
      />
    </>
  )
}
